import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import { regExpMail } from "@/js/regexp_validation.js";
import { request } from "@/js/http/http_request";
import { isAccessTokenExpired } from "@/js/http/auth.js";
import BackgroundVideo from "@/components/default/BackgroundVideo.vue";
export default {
  name: "defaultContact",
  components: {
    BackgroundVideo: BackgroundVideo
  },
  data: function data() {
    return {
      input: {
        first_name: "",
        last_name: "",
        email: "",
        subject: "",
        message: ""
      },
      errorLabels: {
        first_name: "",
        last_name: "",
        email: "",
        subject: "",
        message: ""
      },
      errorMessages: {
        mandatory: "This field is required",
        email: {
          format: "Incorrect format, valid email address expected"
        }
      },
      stepContact: 1
    };
  },
  computed: {
    isUserConnected: function isUserConnected() {
      return !isAccessTokenExpired();
    }
  },
  methods: {
    home: function home() {
      this.$router.push({
        name: "home"
      });
    },
    makeRequest: function makeRequest() {
      var instance = this;
      if (this.validateInputs()) {
        this.input = _objectSpread(_objectSpread({}, this.input), {}, {
          client_id: this.$whitelabel.clientId,
          client_secret: this.$whitelabel.clientSecret
        });
        request("/v1/contact", "post", this.input, false, "api").then(function (response) {
          instance.stepContact = 2;
        }).catch(function (err) {
          instance.$toasted.show("An error occured. Please contact an administrator.", {
            type: "error"
          });
        });
      }
    },
    validateInputs: function validateInputs() {
      this.errorLabels.first_name = "";
      this.errorLabels.last_name = "";
      this.errorLabels.email = "";
      this.errorLabels.subject = "";
      this.errorLabels.message = "";
      var valid = true;
      if (this.input.first_name == "") {
        this.errorLabels.first_name = this.errorMessages.mandatory;
        valid = false;
      }
      if (this.input.last_name == "") {
        this.errorLabels.last_name = this.errorMessages.mandatory;
        valid = false;
      }
      if (this.input.subject == "") {
        this.errorLabels.subject = this.errorMessages.mandatory;
        valid = false;
      }
      if (this.input.message == "") {
        this.errorLabels.message = this.errorMessages.mandatory;
        valid = false;
      }
      if (this.input.email == "") {
        this.errorLabels.email = this.errorMessages.mandatory;
        valid = false;
      } else if (!regExpMail.test(this.input.email)) {
        this.errorLabels.email = this.errorMessages.email.format;
        valid = false;
      }
      return valid;
    }
  }
};